module.exports = __webpack_public_path__ + "ef6e915be2593e930860f41a9b8ef84e.MP3";